import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import styled from "styled-components";

import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import {
  formatNumberWithCommas,
  formatPhoneNumber,
} from "./../../../util/formatNumber";
import RedBtn from "../../../component/atoms/button/redBtn";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import PretendardText from "../../../component/atoms/text/pretendardText";
import BlueBtn from "./../../../component/atoms/button/blueBtn";
import GoBack from "../../../component/molecules/goBack";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "./../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "./../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "./../../../component/atoms/text/detail/detailFormText";
import OrderApi from "../../../api/order.api";
import MemberMerchApi from "../../../api/memberMerch.api";
import { errorHandler } from "../../../util/errorHandler";
import Empty from "../../../component/molecules/empty";
import { fileUrl } from "../../../api/api";
import CancelSalePopup from "../../../component/templates/salesManage/cancelSalePopup";
import CancelApprovePopup from "../../../component/templates/salesManage/cancelApprovePopup";
import CancelRejectPopup from "../../../component/templates/salesManage/cancelRejectPopup";
import AlarmSendPopup from "../../../component/templates/user/userInfo/alarmSendPopup";
import SMSSendPopup from "../../../component/templates/user/userInfo/smsSendPopup";
import Pagination from "../../../component/molecules/pagination";
import { route } from "../../../router/route";

const ShoppingMembershipSellDetail = () => {
  let { id } = useParams();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.shopping_membership_sell)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 팝업 관련 ---------- //
  const [cancelSalePopupOpen, setCancelSalePopupOpen] = useState(false);
  const [cancelApprovePopupOpen, setCancelApprovePopupOpen] = useState(false);
  const [cancelRejectPopupOpen, setCancelRejectPopupOpen] = useState(false);
  const [alarmPopupOpen, setAlarmPopupOpen] = useState(false);
  const [smsPopupOpen, setSMSPopupOpen] = useState(false);

  const [sellInfo, setSellInfo] = useState();
  const [memberMerchList, setMemberMerchList] = useState([]);

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 4, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  useEffect(() => {
    getSellInfoFunc();
  }, []);

  const getSellInfoFunc = async () => {
    try {
      const response = (await OrderApi.getByIdOrder(id)).data.data;

      setSellInfo(response.content);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (sellInfo) {
      getMemberMerchFunc();
    }
  }, [sellInfo, location]);

  const getMemberMerchFunc = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
        memberId: sellInfo.buyerId,
        merchId: sellInfo.merchId,
      };

      const response = (await MemberMerchApi.getList(data)).data.data;

      const processedResponse = await Promise.all(
        response.content.map(async (item) => {
          const img = new Image();

          img.src = `${fileUrl}/${item.merch.thumbnailServerFileName}`;

          img.onload = () => {
            item.imageIsValid = true;
          };

          img.onerror = () => {
            item.imageIsValid = false;
          };

          return item;
        })
      );

      setMemberMerchList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            {isWriteAuthority ? (
              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  gap: 12,
                }}
              >
                {sellInfo?.orderStatus === "PAY_COMPLETE" && (
                  <>
                    <RedBtn
                      style={{
                        backgroundColor: "#272829",
                      }}
                      onClick={() => {
                        setCancelSalePopupOpen(true);
                      }}
                    >
                      판매취소
                    </RedBtn>
                    <GrayBtn
                      onClick={() => {
                        setAlarmPopupOpen(true);
                      }}
                    >
                      알림 보내기
                    </GrayBtn>
                    <GrayBtn
                      onClick={() => {
                        setSMSPopupOpen(true);
                      }}
                    >
                      SMS 보내기
                    </GrayBtn>
                  </>
                )}
                {sellInfo?.orderStatus === "CANCEL_REQUEST" && (
                  <>
                    <BlueBtn
                      style={{
                        backgroundColor: "#272829",
                      }}
                      onClick={() => {
                        setCancelApprovePopupOpen(true);
                      }}
                    >
                      취소 승인
                    </BlueBtn>
                    <RedBtn
                      style={{
                        backgroundColor: "#272829",
                      }}
                      onClick={() => {
                        setCancelRejectPopupOpen(true);
                      }}
                    >
                      취소 거절
                    </RedBtn>
                    <GrayBtn
                      onClick={() => {
                        setAlarmPopupOpen(true);
                      }}
                    >
                      알림 보내기
                    </GrayBtn>
                    <GrayBtn
                      onClick={() => {
                        setSMSPopupOpen(true);
                      }}
                    >
                      SMS 보내기
                    </GrayBtn>
                  </>
                )}
                {(sellInfo?.orderStatus === "CANCEL_COMPLETE" ||
                  sellInfo?.orderStatus === "CANCEL_REJECT") && (
                  <>
                    <GrayBtn
                      onClick={() => {
                        setAlarmPopupOpen(true);
                      }}
                    >
                      알림 보내기
                    </GrayBtn>
                    <GrayBtn
                      onClick={() => {
                        setSMSPopupOpen(true);
                      }}
                    >
                      SMS 보내기
                    </GrayBtn>
                  </>
                )}
              </div>
            ) : null}
          </DetailTop>
          <DetailPage
            style={{
              minHeight: "556px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 40,
              }}
            >
              <DetailPageTitle>
                {sellInfo?.orderStatus === "PAY_COMPLETE" ||
                sellInfo?.orderStatus === "CANCEL_REJECT"
                  ? "구매 "
                  : "취소 "}
                상세 내역
              </DetailPageTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: 50,
                  backgroundColor: "#272829",
                }}
              >
                <PretendardText
                  style={{
                    fontWeight: 700,
                    fontSize: 16,
                    lineHeight: "22.4px",
                    color: "#aaa",
                  }}
                >
                  구매번호 {sellInfo?.payNumber} - {sellInfo?.orderTitle}
                </PretendardText>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 24,
                }}
              >
                <DetailPageForm
                  style={{
                    height: 46,
                  }}
                >
                  <DetailFormTitle>구매 일시</DetailFormTitle>
                  <DetailFormText>
                    {moment(sellInfo?.createdAt).format("YYYY.MM.DD HH:mm:ss")}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    height: 46,
                  }}
                >
                  <DetailFormTitle>구매 상태</DetailFormTitle>
                  <DetailFormText>
                    {sellInfo?.orderStatus === "PAY_COMPLETE"
                      ? "결제 완료"
                      : sellInfo?.orderStatus === "CANCEL_REQUEST"
                      ? "취소 요청"
                      : sellInfo?.orderStatus === "CANCEL_REJECT"
                      ? "취소 거절"
                      : sellInfo?.orderStatus === "CANCEL_COMPLETE"
                      ? "취소 완료"
                      : ""}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    height: 46,
                  }}
                >
                  <DetailFormTitle>결제 금액</DetailFormTitle>
                  <DetailFormText>
                    {formatNumberWithCommas(sellInfo?.realPay)}원
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    height: 46,
                  }}
                >
                  <DetailFormTitle>결제 방식</DetailFormTitle>
                  <DetailFormText>{sellInfo?.payMethod}</DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    height: 46,
                  }}
                >
                  <DetailFormTitle>포인트 사용</DetailFormTitle>
                  <DetailFormText>
                    {formatNumberWithCommas(sellInfo?.pointPay)}P
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    height: 60,
                  }}
                >
                  <DetailFormTitle>쿠폰 사용</DetailFormTitle>
                  <DetailFormText>
                    {sellInfo?.couponTitleList &&
                    sellInfo?.couponTitleList?.length > 0
                      ? sellInfo?.couponTitleList.map((item) => item)
                      : ""}

                    <br />

                    {sellInfo?.couponPay > 0
                      ? `${formatNumberWithCommas(sellInfo?.couponPay)}`
                      : "0"}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    height: 46,
                  }}
                >
                  <DetailFormTitle>구매자 이름</DetailFormTitle>
                  <DetailFormText>{sellInfo?.buyerName}</DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    height: 46,
                  }}
                >
                  <DetailFormTitle>아이디(이메일)</DetailFormTitle>
                  <DetailFormText>{sellInfo?.buyerEmail}</DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    height: 46,
                  }}
                >
                  <DetailFormTitle>구매자 닉네임</DetailFormTitle>
                  <DetailFormText>{sellInfo?.buyerNickname}</DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    height: 46,
                  }}
                >
                  <DetailFormTitle>핸드폰 번호</DetailFormTitle>
                  <DetailFormText>
                    {formatPhoneNumber(sellInfo?.buyerPhoneNumber)}
                  </DetailFormText>
                </DetailPageForm>
              </div>
            </div>
            {/* 결제 합계 & 환불 예정 금액 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 40,
              }}
            >
              <DetailPageTitle>
                {sellInfo?.orderStatus === "PAY_COMPLETE" ||
                sellInfo?.orderStatus === "CANCEL_REJECT"
                  ? "결제 합계"
                  : "환불 예정 금액"}
              </DetailPageTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  backgroundColor: "#272829",
                  padding: "16px 0px 16px 0px",
                  flexDirection: "column",
                  gap: 11,
                }}
              >
                {/* 결제 완료, 취소 거절인 경우 */}
                {(sellInfo?.orderStatus === "PAY_COMPLETE" ||
                  sellInfo?.orderStatus === "CANCEL_REJECT") && (
                  <>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 30px",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        상품 금액
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        {formatNumberWithCommas(sellInfo?.totalPay)}원
                      </PretendardText>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 30px",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        포인트 결제
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        - {formatNumberWithCommas(sellInfo?.pointPay)}원
                      </PretendardText>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 30px",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        쿠폰 할인
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        - {formatNumberWithCommas(sellInfo?.couponPay)}원
                      </PretendardText>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        height: 1,
                        backgroundColor: "rgba(255, 255, 255, 0.12)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 30px",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 700,
                          fontSize: 16,
                          lineHeight: "22.4px",
                          color: "#aaa",
                        }}
                      >
                        합계
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 700,
                          fontSize: 16,
                          lineHeight: "22.4px",
                          color: "#aaa",
                        }}
                      >
                        {formatNumberWithCommas(sellInfo?.realPay)}원
                      </PretendardText>
                    </div>
                  </>
                )}

                {/* 취소 요청, 취소 완료인 경우 */}
                {(sellInfo?.orderStatus === "CANCEL_REQUEST" ||
                  sellInfo?.orderStatus === "CANCEL_COMPLETE") && (
                  <>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 30px",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        구매 금액
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        {formatNumberWithCommas(sellInfo?.realPay)}원
                      </PretendardText>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 30px",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        {sellInfo?.refundAllFlag ? "전체 취소" : "부분 취소"}
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        {formatNumberWithCommas(
                          sellInfo?.refundAllFlag
                            ? sellInfo?.realPay
                            : sellInfo?.refundAmount
                            ? sellInfo?.refundAmount
                            : 0
                        )}
                        원
                      </PretendardText>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 30px",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        포인트 취소
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        {formatNumberWithCommas(
                          sellInfo?.refundPointAmount
                            ? sellInfo?.refundPointAmount
                            : 0
                        )}
                        원
                      </PretendardText>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 30px",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        쿠폰 취소
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "21px",
                          color: "#aaa",
                        }}
                      >
                        {formatNumberWithCommas(
                          sellInfo?.refundCouponAmount
                            ? sellInfo?.refundCouponAmount
                            : 0
                        )}
                        원
                      </PretendardText>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: 1,
                        backgroundColor: "rgba(255, 255, 255, 0.12)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 30px",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 700,
                          fontSize: 16,
                          lineHeight: "22.4px",
                          color: "#aaa",
                        }}
                      >
                        합계
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 700,
                          fontSize: 16,
                          lineHeight: "22.4px",
                          color: "#aaa",
                        }}
                      >
                        {formatNumberWithCommas(
                          sellInfo?.refundAllFlag
                            ? sellInfo?.refundAmount +
                                sellInfo?.refundCouponAmount +
                                sellInfo?.refundPointAmount
                            : sellInfo?.refundAmount
                            ? sellInfo?.refundAmount
                            : 0
                        )}
                        원
                      </PretendardText>
                    </div>
                  </>
                )}
              </div>
            </div>
            {(sellInfo?.orderStatus === "CANCEL_REQUEST" ||
              sellInfo?.orderStatus === "CANCEL_COMPLETE") && (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: 40,
                  }}
                >
                  <DetailPageTitle>사용자의 학습 내용</DetailPageTitle>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      columnGap: 26,
                      rowGap: 24,
                    }}
                  >
                    {memberMerchList.length > 0 ? (
                      memberMerchList.map((item, index) => {
                        return (
                          <UserLearningContentContainer key={index}>
                            {item.imageIsValid ? (
                              <img
                                style={{
                                  width: 154,
                                  height: 168,
                                  borderRadius: 5,
                                  objectFit: "cover",
                                }}
                                src={`${fileUrl}/${item.merch.thumbnailServerFileName}`}
                                alt=""
                              />
                            ) : (
                              <div
                                style={{
                                  width: 154,
                                  height: 168,
                                  borderRadius: 5,
                                  boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.25)",
                                }}
                              >
                                {""}
                              </div>
                            )}
                            <UserLearningContentWrapper>
                              <UserLearningContentAuthor>
                                {item.merch.writer}
                              </UserLearningContentAuthor>
                              <UserLearningContentTitle>
                                {item.merch.title}
                              </UserLearningContentTitle>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 3,
                                  marginBottom: 7.5,
                                }}
                              >
                                <img
                                  style={{
                                    width: 16,
                                    height: 16,
                                  }}
                                  src="/assets/admin/icons/ico_star_fill.svg"
                                  alt="별점"
                                />
                                <UserLearningContentReviewGradeText>
                                  {item.merch.reviewScore}
                                </UserLearningContentReviewGradeText>
                                <UserLearningContentReviewGradeText>
                                  (
                                  {formatNumberWithCommas(
                                    item.merch.reviewCount
                                  )}
                                  )
                                </UserLearningContentReviewGradeText>
                              </div>
                              <PretendardText
                                style={{
                                  fontWeight: 700,
                                  fontSize: 16,
                                  lineHeight: "22.4px",
                                  color: "#3a96df",
                                }}
                              >
                                {item.progressPercent}%
                              </PretendardText>
                            </UserLearningContentWrapper>
                          </UserLearningContentContainer>
                        );
                      })
                    ) : (
                      <Empty />
                    )}

                    {/* 페이지네이션 영역 */}
                    <Pagination
                      route={route.shopping_membership_sell_detail}
                      queryString={``}
                      currentPage={page}
                      totalPages={pagination.totalPages}
                      rangeSize={pagination.rangeSize}
                      first={pagination.first}
                      last={pagination.last}
                    />
                  </div>
                </div>
              </>
            )}
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {cancelSalePopupOpen && (
        <CancelSalePopup
          setPopupOpen={setCancelSalePopupOpen}
          sellData={sellInfo}
          getSellList={getSellInfoFunc}
        />
      )}

      {cancelApprovePopupOpen && (
        <CancelApprovePopup
          setPopupOpen={setCancelApprovePopupOpen}
          sellData={sellInfo}
          getSellList={getSellInfoFunc}
        />
      )}

      {cancelRejectPopupOpen && (
        <CancelRejectPopup
          setPopupOpen={setCancelRejectPopupOpen}
          sellData={sellInfo}
          getSellList={getSellInfoFunc}
        />
      )}

      {/* 알림 보내기 */}
      {alarmPopupOpen && (
        <AlarmSendPopup
          setPopupOpen={setAlarmPopupOpen}
          userCheckedIdList={[
            {
              id: sellInfo?.buyerId,
              email: sellInfo?.buyerEmail,
            },
          ]}
          getMemberList={() => {}}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}

      {/* SMS 보내기 */}
      {smsPopupOpen && (
        <SMSSendPopup
          setPopupOpen={setSMSPopupOpen}
          userCheckedIdList={[
            {
              phoneNumber: sellInfo?.buyerPhoneNumber,
            },
          ]}
          getMemberList={() => {}}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}
    </>
  );
};

export default ShoppingMembershipSellDetail;

const UserLearningContentContainer = styled.div.attrs((props) => {})`
  display: flex;
  width: 509px;
  height: 210px;
  padding: 20px;
  gap: 20px;
  border-radius: 10px;
  background-color: #272829;
  box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.13);
`;

const UserLearningContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
`;

const UserLearningContentAuthor = styled(PretendardText).attrs((props) => {})`
  font-weight: 400;
  font-size: 12px;
  line-height: 15.6px;
  color: #aaa;
  margin-bottom: 7px;
`;

const UserLearningContentTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 18px;
  line-height: 24.3px;
  color: #aaa;
  width: 207px;
  margin-bottom: 10px;
`;

const UserLearningContentReviewGradeText = styled(PretendardText).attrs(
  (props) => {}
)`
  font-weight: 400;
  font-size: 14px;
  line-height: 19.6px;
  color: #aaa;
`;
